/**
 * Batch 27h — Offset-based pager for the SA Tenants table.
 *
 * OQ-4 default: offset-based pagination (vs cursor) is fine at v1 scale
 * (low hundreds of tenants); cursor swap-in is a later enhancement.
 */
interface Props {
  totalCount: number;
  limit: number;
  offset: number;
  onOffset: (next: number) => void;
}

export function TenantsPager({
  totalCount,
  limit,
  offset,
  onOffset,
}: Props): JSX.Element {
  const start = totalCount === 0 ? 0 : offset + 1;
  const end = Math.min(offset + limit, totalCount);
  const hasPrev = offset > 0;
  const hasNext = offset + limit < totalCount;

  return (
    <div className="flex items-center justify-between text-sm text-text-secondary dark:text-brand-100/70">
      <span>
        Showing {start}–{end} of {totalCount}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={!hasPrev}
          onClick={() => onOffset(Math.max(0, offset - limit))}
          className="rounded border border-brand-200 px-3 py-1 text-xs font-medium text-text-secondary hover:bg-surface-canvas disabled:opacity-40 dark:border-white/[0.08] dark:text-brand-100/80 dark:hover:bg-white/[0.04]"
        >
          ‹ Prev
        </button>
        <button
          type="button"
          disabled={!hasNext}
          onClick={() => onOffset(offset + limit)}
          className="rounded border border-brand-200 px-3 py-1 text-xs font-medium text-text-secondary hover:bg-surface-canvas disabled:opacity-40 dark:border-white/[0.08] dark:text-brand-100/80 dark:hover:bg-white/[0.04]"
        >
          Next ›
        </button>
      </div>
    </div>
  );
}
